/**
 * Address Card Component (JavaScript)
 * Standardized client-side handlers for address display and edit modes,
 * zip/postal code autofill, address selection, and contact person management.
 */

(function () {
    if (window._addressComponentInitialized) return;
    window._addressComponentInitialized = true;

    window.enableAddressEdit = function (prefix) {
        const displayEl = document.getElementById(`${prefix}-display`);
        const editEl = document.getElementById(`${prefix}-edit`);
        const editBtn = document.getElementById(`edit-${prefix}-btn`);
        if (displayEl) displayEl.style.display = 'none';
        if (editEl) editEl.style.display = 'block';
        if (editBtn) editBtn.style.display = 'none';

        if (window.bindPincodeAutofill) {
            window.bindPincodeAutofill(prefix);
        }
    };

    window.updateContactReadonly = function (prefix) {
        const cardWrapper = document.getElementById(`${prefix}-address-card-wrapper`);
        const showContact = cardWrapper ? (cardWrapper.dataset.showContactSection === 'true') : false;
        const contactBox = document.getElementById(`${prefix}-contact-readonly`);
        if (!contactBox) return;

        if (!showContact) {
            contactBox.style.display = 'none';
            return;
        }

        // Resolve Contact Person Name
        let contactName = '';
        const contactSel = document.getElementById(`${prefix}_contact_select`);
        if (contactSel && contactSel.value) {
            if (contactSel.tagName === 'SELECT' && contactSel.options) {
                const opt = contactSel.options[contactSel.selectedIndex];
                contactName = opt ? opt.text.trim() : '';
            } else {
                const contacts = window.checkoutCustomerContacts || window.customerContacts || [];
                const c = contacts.find(item => item.name === contactSel.value);
                contactName = c?.full_name || c?.name || '';
            }
            if (contactName === 'Select a contact' || contactName === contactSel.value) {
                contactName = '';
            }
        }
        if (!contactName) {
            contactName = document.getElementById(`${prefix}_contact_fullname`)?.value?.trim() || '';
        }
        if (!contactName) {
            const personId = document.getElementById(`${prefix}_contact_name`)?.value?.trim() || '';
            if (personId) {
                const c = (window.checkoutCustomerContacts || window.customerContacts || []).find(item => item.name === personId);
                contactName = c?.full_name || c?.name || personId;
            }
        }

        // Resolve Email and Phone
        const email = document.getElementById(`${prefix}_email_id`)?.value?.trim() || '';
        const phone = document.getElementById(`${prefix}_phone`)?.value?.trim() || '';

        // Check if an address is selected or being displayed
        const existEl = document.getElementById(`${prefix}_existing_name`) || document.getElementById(`${prefix}_address_name`);
        const line1El = document.getElementById(`${prefix}_line1`) || document.getElementById(`${prefix}_address_line1`);
        const displayEl = document.getElementById(`${prefix}-address-display-content`);
        const hasPending = displayEl && displayEl.querySelector('.address-pending-box');
        const hasAddr = Boolean((existEl && existEl.value) || (line1El && line1El.value) || (displayEl && !hasPending && displayEl.textContent.trim()));

        if (!hasAddr) {
            contactBox.style.display = 'none';
            return;
        }

        const nameRow = document.getElementById(`${prefix}-contact-name-row`);
        const nameVal = document.getElementById(`${prefix}-contact-display-name`);
        const emailRow = document.getElementById(`${prefix}-contact-email-row`);
        const emailVal = document.getElementById(`${prefix}-contact-display-email`);
        const phoneRow = document.getElementById(`${prefix}-contact-phone-row`);
        const phoneVal = document.getElementById(`${prefix}-contact-display-phone`);

        const emptyNameText = (typeof __ === 'function' ? __('No contact person saved') : 'No contact person saved');
        const emptyEmailText = (typeof __ === 'function' ? __('No email address saved') : 'No email address saved');
        const emptyPhoneText = (typeof __ === 'function' ? __('No phone number saved') : 'No phone number saved');

        if (nameVal) {
            nameVal.textContent = contactName || emptyNameText;
            nameVal.classList.toggle('is-empty', !contactName);
        }
        if (nameRow) {
            nameRow.style.display = 'flex';
            nameRow.classList.toggle('is-empty', !contactName);
        }

        if (emailVal) {
            emailVal.textContent = email || emptyEmailText;
            emailVal.classList.toggle('is-empty', !email);
        }
        if (emailRow) {
            emailRow.style.display = 'flex';
            emailRow.classList.toggle('is-empty', !email);
        }

        if (phoneVal) {
            phoneVal.textContent = phone || emptyPhoneText;
            phoneVal.classList.toggle('is-empty', !phone);
        }
        if (phoneRow) {
            phoneRow.style.display = 'flex';
            phoneRow.classList.toggle('is-empty', !phone);
        }

        contactBox.style.display = 'block';

        if (window.lucide && typeof window.lucide.createIcons === 'function') {
            window.lucide.createIcons({ root: contactBox });
        }
    };

    window.clearAddressValidation = function (prefix) {
        const fieldIds = [
            `${prefix}_line1`, `${prefix}_address_line1`,
            `${prefix}_pincode`,
            `${prefix}_email_id`,
            `${prefix}_phone`
        ];
        fieldIds.forEach(id => {
            const el = document.getElementById(id);
            if (el) {
                el.classList.remove('is-invalid');
                el.style.removeProperty('border-color');
                el.style.removeProperty('box-shadow');
                el.style.borderColor = '';
                el.style.boxShadow = '';
            }
        });
        const feedback = document.getElementById(`${prefix}-address-feedback`);
        if (feedback && feedback.style.color !== '#16a34a' && feedback.style.color !== 'rgb(22, 163, 74)') {
            feedback.textContent = '';
        }
    };

    window.validateAddressCard = function (prefix) {
        const cardWrapper = document.getElementById(`${prefix}-address-card-wrapper`);
        const showContact = cardWrapper ? (cardWrapper.dataset.showContactSection === 'true') : false;

        const line1El = document.getElementById(`${prefix}_line1`) || document.getElementById(`${prefix}_address_line1`);
        const pincodeEl = document.getElementById(`${prefix}_pincode`);
        const emailEl = document.getElementById(`${prefix}_email_id`);
        const phoneEl = document.getElementById(`${prefix}_phone`);

        const rules = [
            { el: line1El, label: 'Address Line 1' },
            { el: pincodeEl, label: 'ZIP / Postal Code' }
        ];

        if (showContact && emailEl && emailEl.type !== 'hidden') {
            rules.push({ el: emailEl, label: 'Contact Email' });
        }
        if (showContact && phoneEl && phoneEl.type !== 'hidden') {
            rules.push({ el: phoneEl, label: 'Phone' });
        }

        let firstInvalid = null;
        let hasErrors = false;

        rules.forEach(({ el }) => {
            if (!el) return;
            const val = (el.value || '').trim();
            if (!val) {
                hasErrors = true;
                el.classList.add('is-invalid');
                el.style.setProperty('border-color', '#ef4444', 'important');
                el.style.setProperty('box-shadow', '0 0 0 1px #ef4444', 'important');
                if (!firstInvalid) firstInvalid = el;

                if (!el.dataset.validationBound) {
                    el.dataset.validationBound = 'true';
                    el.addEventListener('input', function () {
                        if (this.value.trim()) {
                            this.classList.remove('is-invalid');
                            this.style.removeProperty('border-color');
                            this.style.removeProperty('box-shadow');
                            this.style.borderColor = '';
                            this.style.boxShadow = '';
                        }
                    });
                }
            } else {
                el.classList.remove('is-invalid');
                el.style.removeProperty('border-color');
                el.style.removeProperty('box-shadow');
                el.style.borderColor = '';
                el.style.boxShadow = '';
            }
        });

        const feedback = document.getElementById(`${prefix}-address-feedback`);
        if (hasErrors) {
            if (feedback) {
                feedback.style.color = '#ef4444';
                feedback.textContent = 'Please fill in all mandatory fields (*).';
            }
            if (firstInvalid) {
                firstInvalid.focus();
            }
            return false;
        }

        if (feedback && feedback.style.color !== '#16a34a' && feedback.style.color !== 'rgb(22, 163, 74)') {
            feedback.textContent = '';
        }
        return true;
    };

    window.cancelAddressEdit = function (prefix) {
        if (window.clearAddressValidation) window.clearAddressValidation(prefix);
        const displayEl = document.getElementById(`${prefix}-display`);
        const editEl = document.getElementById(`${prefix}-edit`);
        const editBtn = document.getElementById(`edit-${prefix}-btn`);
        const feedback = document.getElementById(`${prefix}-address-feedback`);
        if (displayEl) displayEl.style.display = 'block';
        if (editEl) editEl.style.display = 'none';

        const isLocalPickup = (prefix === 'shipping') && (
            document.getElementById('toggle-local-pickup')?.checked || 
            (document.getElementById('local-pickup-info') && document.getElementById('local-pickup-info').style.display !== 'none')
        );
        if (editBtn) editBtn.style.display = isLocalPickup ? 'none' : 'inline-flex';
        if (feedback) feedback.textContent = '';
        const existEl = document.getElementById(`${prefix}_existing_name`) || document.getElementById(`${prefix}_address_name`);
        const existName = existEl ? existEl.value : '';

        const selectEl = document.getElementById(`${prefix}_address_select`);
        if (selectEl) {
            selectEl.value = existName;
            if (window.Accordion && typeof window.Accordion.select === 'function') {
                window.Accordion.select(`${prefix}_address_select`, existName);
            }
        }

        const addressBook = window.checkoutAddressBook || window.allAddresses || [];
        const originalAddr = existName ? addressBook.find(a => a.name === existName) : null;
        if (originalAddr) {
            window.applyAddressData(prefix, originalAddr);
        } else if (existName && window.frappe && frappe.call) {
            frappe.call({
                method: 'frappe.client.get',
                args: { doctype: 'Address', name: existName },
                callback: function (r) {
                    if (r.message) window.applyAddressData(prefix, r.message);
                }
            });
        } else {
            window.clearAddress(prefix);
        }

        if (existName && window.renderAddressDisplay) {
            window.renderAddressDisplay(prefix, existName);
        }
    };

    window.setLocalPickupUI = function (isChecked) {
        const localPickupInfo = document.getElementById('local-pickup-info');
        const shippingContainer = document.getElementById('shipping-address-container');
        const editBtn = document.getElementById('edit-shipping-btn');
        if (localPickupInfo) {
            localPickupInfo.style.display = isChecked ? '' : 'none';
            if (isChecked && window.lucide && typeof window.lucide.createIcons === 'function') {
                window.lucide.createIcons({ root: localPickupInfo });
            }
        }
        if (shippingContainer) shippingContainer.style.display = isChecked ? 'none' : '';
        if (editBtn) editBtn.style.display = isChecked ? 'none' : 'inline-flex';
    };

    window.renderAddressDisplay = async function (prefix, addressName, customerName) {
        const displayEl = document.getElementById(`${prefix}-display`);
        if (!displayEl) return;

        if (!addressName) {
            const existEl = document.getElementById(`${prefix}_existing_name`) || document.getElementById(`${prefix}_address_name`);
            addressName = existEl?.value || '';
        }
        if (!addressName) return;

        const selectEl = document.getElementById(`${prefix}_address_select`);
        if (selectEl && addressName) {
            if (selectEl.tagName === 'SELECT') {
                let opt = Array.from(selectEl.options || []).find(o => o.value === addressName);
                if (!opt) {
                    opt = document.createElement('option');
                    opt.value = addressName;
                    opt.textContent = addressName;
                    selectEl.appendChild(opt);
                }
            }
            selectEl.value = addressName;
            if (window.Accordion && typeof window.Accordion.select === 'function') {
                window.Accordion.select(`${prefix}_address_select`, addressName);
            }
        }

        if (!customerName) {
            const custEl = document.getElementById(`${prefix}_customer_name`);
            customerName = custEl?.value || window.checkoutCustomerName || '';
        }
        const context = (prefix === 'shipping') ? 'shipping' : 'billing';

        const fetchFn = window.fetchDisplay || window.fetchAddressDisplay;
        if (typeof fetchFn === 'function') {
            try {
                let html = await fetchFn(addressName, customerName, context, "website");
                if (html) {
                    const cardWrapper = document.getElementById(`${prefix}-address-card-wrapper`);
                    const allowEdit = cardWrapper ? (cardWrapper.dataset.allowEdit !== 'false' || cardWrapper.dataset.showContactSection === 'true') : true;
                    const isLocalPickup = (prefix === 'shipping') && (
                        document.getElementById('toggle-local-pickup')?.checked || 
                        (document.getElementById('local-pickup-info') && document.getElementById('local-pickup-info').style.display !== 'none')
                    );
                    if (!allowEdit || isLocalPickup) {
                        if (window.stripEditButton) {
                            html = window.stripEditButton(html);
                        }
                    }
                    const contentEl = document.getElementById(`${prefix}-address-display-content`) || displayEl;
                    contentEl.innerHTML = html;
                    if (window.lucide && typeof window.lucide.createIcons === 'function') {
                        window.lucide.createIcons({ root: contentEl });
                    }
                    if (typeof window.updateContactReadonly === 'function') {
                        window.updateContactReadonly(prefix);
                    }
                    return;
                }
            } catch (err) {
                console.warn(`Error fetching address display for ${prefix}:`, err);
            }
        }
    };

    window.applyAddressData = function (prefix, addr) {
        if (!addr) {
            window.clearAddress(prefix);
            return;
        }

        const setVal = (id, v) => { const el = document.getElementById(id); if (el) el.value = v || ''; };

        setVal(`${prefix}_existing_name`, addr.name);
        setVal(`${prefix}_address_name`, addr.name);
        setVal(`${prefix}_title`, addr.address_title);
        setVal(`${prefix}_address_title`, addr.address_title);
        setVal(`${prefix}_line1`, addr.address_line1);
        setVal(`${prefix}_line2`, addr.address_line2);
        setVal(`${prefix}_city`, addr.city);
        setVal(`${prefix}_state`, addr.state);
        setVal(`${prefix}_pincode`, addr.pincode);
        setVal(`${prefix}_country`, addr.country || 'United States');
        if (window.Accordion && typeof window.Accordion.select === 'function') {
            window.Accordion.select(`${prefix}_country`, addr.country || 'United States');
            window.Accordion.select(`${prefix}_address_select`, addr.name || '');
        }

        const countryEl = document.getElementById(`${prefix}_country`);
        if (countryEl) countryEl.dispatchEvent(new Event('change'));

        // Contact info if available
        const contactPerson = addr.custom_contact_person || '';
        setVal(`${prefix}_contact_name`, contactPerson);
        setVal(`${prefix}_contact_select`, contactPerson);
        if (window.Accordion && typeof window.Accordion.select === 'function') {
            window.Accordion.select(`${prefix}_contact_select`, contactPerson);
        }

        const fullnameRow = document.getElementById(`${prefix}_contact_fullname_row`);
        if (fullnameRow) fullnameRow.style.display = 'none';
        const fullnameEl = document.getElementById(`${prefix}_contact_fullname`);
        if (fullnameEl) fullnameEl.value = '';

        let email = addr.email_id || '';
        let phone = addr.phone || '';
        if ((!email || !phone) && contactPerson) {
            const contacts = window.checkoutCustomerContacts || window.customerContacts || [];
            const c = contacts.find(item => item.name === contactPerson);
            if (c) {
                if (!email && c.email_id) email = c.email_id;
                if (!phone && c.phone) phone = c.phone;
            }
        }
        setVal(`${prefix}_email_id`, email);
        setVal(`${prefix}_phone`, phone);

        if (typeof window.updateContactReadonly === 'function') {
            window.updateContactReadonly(prefix);
        }
    };

    window.populateAddress = function (prefix) {
        window.enableAddressEdit(prefix);

        const selectEl = document.getElementById(`${prefix}_address_select`);
        const val = selectEl ? selectEl.value : '';
        if (!val) {
            window.clearAddress(prefix);
            return;
        }

        const addressBook = window.checkoutAddressBook || window.allAddresses || [];
        const addr = addressBook.find(a => a.name === val);
        if (addr) {
            window.applyAddressData(prefix, addr);
        } else if (window.frappe && frappe.call) {
            frappe.call({
                method: 'frappe.client.get',
                args: { doctype: 'Address', name: val },
                callback: function (r) {
                    if (r.message) window.applyAddressData(prefix, r.message);
                }
            });
        }
    };

    window.clearAddress = function (prefix) {
        if (window.clearAddressValidation) window.clearAddressValidation(prefix);
        const setVal = (id, v) => { const el = document.getElementById(id); if (el) el.value = v || ''; };
        setVal(`${prefix}_address_select`, '');
        if (window.Accordion && typeof window.Accordion.select === 'function') {
            window.Accordion.select(`${prefix}_address_select`, '');
        }
        setVal(`${prefix}_existing_name`, '');
        setVal(`${prefix}_address_name`, '');
        setVal(`${prefix}_title`, '');
        setVal(`${prefix}_address_title`, '');
        setVal(`${prefix}_line1`, '');
        setVal(`${prefix}_address_line1`, '');
        setVal(`${prefix}_line2`, '');
        setVal(`${prefix}_address_line2`, '');
        setVal(`${prefix}_city`, '');
        setVal(`${prefix}_state`, '');
        setVal(`${prefix}_pincode`, '');
        setVal(`${prefix}_country`, 'United States');
        if (window.Accordion && typeof window.Accordion.select === 'function') {
            window.Accordion.select(`${prefix}_country`, 'United States');
        }

        setVal(`${prefix}_contact_select`, '');
        if (window.Accordion && typeof window.Accordion.select === 'function') {
            window.Accordion.select(`${prefix}_contact_select`, '');
        }
        setVal(`${prefix}_contact_name`, '');
        setVal(`${prefix}_contact_fullname`, '');
        setVal(`${prefix}_email_id`, '');
        setVal(`${prefix}_phone`, '');

        const fullnameRow = document.getElementById(`${prefix}_contact_fullname_row`);
        if (fullnameRow) fullnameRow.style.display = 'none';

        const countryEl = document.getElementById(`${prefix}_country`);
        if (countryEl) countryEl.dispatchEvent(new Event('change'));

        if (typeof window.updateContactReadonly === 'function') {
            window.updateContactReadonly(prefix);
        }
    };

    async function _lookupByPincode(pincode, country) {
        if (!pincode || !country) return null;
        const simpleMap = {
            'United States': 'US', 'India': 'IN', 'Canada': 'CA',
            'United Kingdom': 'GB', 'Australia': 'AU', 'Germany': 'DE',
            'France': 'FR', 'Mexico': 'MX', 'Brazil': 'BR'
        };
        const countryCode = simpleMap[country] || (country.length === 2 ? country.toUpperCase() : 'US');
        try {
            const res = await fetch(`https://api.zippopotam.us/${countryCode.toLowerCase()}/${encodeURIComponent(pincode)}`);
            if (!res.ok) return null;
            const data = await res.json();
            const place = (data.places || [])[0];
            if (!place) return null;
            return {
                city: place['place name'] || '',
                state: place['state abbreviation'] || place['state'] || '',
                country: data.country || country
            };
        } catch { return null; }
    }

    window.bindPincodeAutofill = function (prefix) {
        const pinEl = document.getElementById(`${prefix}_pincode`);
        const cityEl = document.getElementById(`${prefix}_city`);
        const stateEl = document.getElementById(`${prefix}_state`);
        const ctryEl = document.getElementById(`${prefix}_country`);
        if (!pinEl || pinEl.dataset.autofillBound) return;
        pinEl.dataset.autofillBound = 'true';

        function updateReadonly() {
            const isUS = (ctryEl?.value || '') === 'United States';
            if (cityEl) {
                cityEl.readOnly = isUS;
                cityEl.style.background = isUS ? '#f3f4f6' : '#fff';
            }
            if (stateEl) {
                stateEl.readOnly = isUS;
                stateEl.style.background = isUS ? '#f3f4f6' : '#fff';
            }
        }
        ctryEl?.addEventListener('change', updateReadonly);
        updateReadonly();

        let debounceTimer;
        pinEl.addEventListener('input', function () {
            clearTimeout(debounceTimer);
            const val = this.value.trim();
            if (val.length < 3) return;
            debounceTimer = setTimeout(async () => {
                const ctry = ctryEl?.value || 'United States';
                const res = await _lookupByPincode(val, ctry);
                if (res) {
                    if (cityEl && (!cityEl.value || (ctryEl?.value === 'United States'))) cityEl.value = res.city;
                    if (stateEl && (!stateEl.value || (ctryEl?.value === 'United States'))) stateEl.value = res.state;
                    updateReadonly();
                }
            }, 450);
        });
    };

    // Global Delegated Listeners for Address Components
    document.addEventListener('click', function (e) {
        const target = e.target.closest('[id$="_new_contact"]');
        if (!target) return;
        const prefix = target.id.replace('_new_contact', '');
        const contactSel = document.getElementById(`${prefix}_contact_select`);
        const contactNameEl = document.getElementById(`${prefix}_contact_name`);
        const fullnameRow = document.getElementById(`${prefix}_contact_fullname_row`);
        const fullnameEl = document.getElementById(`${prefix}_contact_fullname`);
        const emailEl = document.getElementById(`${prefix}_email_id`);
        const phoneEl = document.getElementById(`${prefix}_phone`);
        if (contactSel) contactSel.value = '';
        if (window.Accordion && typeof window.Accordion.select === 'function') {
            window.Accordion.select(`${prefix}_contact_select`, '');
        }
        if (contactNameEl) contactNameEl.value = '';
        if (emailEl) emailEl.value = '';
        if (phoneEl) phoneEl.value = '';
        if (fullnameRow) fullnameRow.style.display = '';
        if (fullnameEl) { fullnameEl.value = ''; fullnameEl.focus(); }
    });

    document.addEventListener('change', function (e) {
        const target = e.target.closest('[id$="_contact_select"]');
        if (!target) return;
        const prefix = target.id.replace('_contact_select', '');
        const contactNameEl = document.getElementById(`${prefix}_contact_name`);
        const emailEl = document.getElementById(`${prefix}_email_id`);
        const phoneEl = document.getElementById(`${prefix}_phone`);
        const fullnameRow = document.getElementById(`${prefix}_contact_fullname_row`);
        const contacts = window.checkoutCustomerContacts || window.customerContacts || [];
        const selected = contacts.find(c => c.name === target.value);
        if (contactNameEl) contactNameEl.value = target.value || '';
        if (fullnameRow) fullnameRow.style.display = 'none';
        if (selected) {
            if (emailEl && selected.email_id) emailEl.value = selected.email_id;
            if (phoneEl && selected.phone) phoneEl.value = selected.phone;
        }
        if (typeof window.updateContactReadonly === 'function') {
            window.updateContactReadonly(prefix);
        }
    });

    document.addEventListener('change', function (e) {
        const target = e.target;
        if (target && target.id && target.id.endsWith('_address_select')) {
            const prefix = target.id.replace('_address_select', '');
            if (typeof window.populateAddress === 'function') {
                window.populateAddress(prefix);
            }
        }
    });

    // Delegated click handler for the edit pencil button inside .custom-address-display
    document.addEventListener('click', function (e) {
        const link = e.target.closest('.edit-btn[data-address-name]');
        if (!link) return;
        const cardWrapper = link.closest("[id$='-address-card-wrapper']");
        if (cardWrapper) {
            e.preventDefault();
            e.stopPropagation();
            const prefix = cardWrapper.id.replace('-address-card-wrapper', '');
            const isLocalPickup = (prefix === 'shipping') && (
                document.getElementById('toggle-local-pickup')?.checked || 
                (document.getElementById('local-pickup-info') && document.getElementById('local-pickup-info').style.display !== 'none')
            );
            const allowEdit = cardWrapper.dataset.allowEdit !== 'false' || cardWrapper.dataset.showContactSection === 'true';
            if (allowEdit && !isLocalPickup) {
                window.enableAddressEdit(prefix);
            }
        }
    });

    window.initAddressDisplays = function () {
        const fetchFn = window.fetchDisplay || window.fetchAddressDisplay;
        if (typeof fetchFn !== 'function') {
            setTimeout(window.initAddressDisplays, 50);
            return;
        }
        ['billing', 'shipping'].forEach(prefix => {
            const existEl = document.getElementById(`${prefix}_existing_name`) || document.getElementById(`${prefix}_address_name`);
            if (existEl && existEl.value && window.renderAddressDisplay) {
                window.renderAddressDisplay(prefix, existEl.value);
            } else if (typeof window.updateContactReadonly === 'function') {
                window.updateContactReadonly(prefix);
            }
        });
        const localPickupInfo = document.getElementById('local-pickup-info');
        if (localPickupInfo && localPickupInfo.style.display !== 'none' && window.lucide && typeof window.lucide.createIcons === 'function') {
            window.lucide.createIcons({ root: localPickupInfo });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(window.initAddressDisplays, 50);
        });
    } else {
        setTimeout(window.initAddressDisplays, 50);
    }
})();
